import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatRadioModule } from '@angular/material/radio';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { TippyDirective } from '@ngneat/helipopper';
import { ConditionBuilderComponent } from './condition-builder.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    MatSelectModule,
    MatDatepickerModule,
    MatRadioModule,
    MatIconModule,
    MatMenuModule,
    TippyDirective
  ],
  declarations: [ConditionBuilderComponent],
  exports: [ConditionBuilderComponent]
})
export class ConditionBuilderModule {
  public static forRoot(environment: any): ModuleWithProviders<ConditionBuilderModule> {
    return {
      ngModule: ConditionBuilderModule,
      providers: [{ provide: 'environment', useValue: environment }]
    };
  }
}
